import clsx from 'clsx';
import * as React from 'react';
import {
    ColorArea as RACColorArea,
    type ColorAreaProps as RACColorAreaProps,
} from 'react-aria-components';

export type ColorAreaProps = RACColorAreaProps;

/**
 * A color area allows users to adjust two channels of an RGB,
 * HSL or HSB color value against a two-dimensional gradient background.
 */
export const ColorArea = React.forwardRef(function ColorArea(
    props: ColorAreaProps,
    ref: React.ForwardedRef<HTMLDivElement>
) {
    return (
        <RACColorArea
            ref={ref}
            {...props}
            className={clsx('group/color-area', 'shrink-0 rounded', props.className)}
        />
    );
});
